<div class="d-flex flex-column align-items-center my-5">
  <h1>Accès non autorisé</h1>
  @if (!codeChantier) {
    <p>Vous n’avez accès à aucun chantier.</p>
    <p>Merci de contacter <a href="mailto:applications.chantiers@leongrosse.fr">applications.chantiers&#64;leongrosse.fr</a>.</p>
  }
  @if (codeChantier) {
    <p>Vous n'avez pas le droit d'accéder au suivi du registre du personnel chantier pour le chantier {{codeChantier}}. Contactez votre administrateur.</p>
    <button class="btn btn-primary" routerLink="/">Retourner à l'accueil</button>
  }
</div>
